import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makePath } from 'helpers/link-generation';

import Avatar from 'components/Avatar';
import SvgEdit from 'components/Svgs/Edit';

const INSTRUCTOR_HEADER_AVATAR_SIZE_IN_PX = 69;

const InstructorDetailsHeader = ({ firstName, lastName, pictureUrl, instructorId, venueId }) => {
  const fullName = `${firstName} ${lastName || ''}`;

  return (
    <header className="instructor-details__header" data-cypress="instructor-details-header">
      <Avatar size={INSTRUCTOR_HEADER_AVATAR_SIZE_IN_PX} url={pictureUrl} name={fullName} />
      <h2 className="instructor-details__header-title">{fullName}</h2>
      <Link to={makePath.instructorsEdit({ instructorId, venueId })}>
        <SvgEdit className="instructor-details__edit-icon text--right" data-cypress="instructor-edit-button" />
      </Link>
    </header>
  );
};

InstructorDetailsHeader.propTypes = {
  pictureUrl: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  instructorId: PropTypes.number,
  venueId: PropTypes.number,
};

export default InstructorDetailsHeader;
